import * as schemas from "./schemas";
import { CLIENT_TOKEN } from "shadow-client";
import { HydraClient } from "shadow-client/axios/";
import generator from "shadow-client/endpoints/generator";

// sales
const saleGenerator = generator.with(`/${CLIENT_TOKEN}/sales`, schemas.sale);
export const fetchSale = saleGenerator.fetchEntity;
export const saveSale = saleGenerator.saveEntity;
export const deleteSale = saleGenerator.deleteEntity;
export const postSaleTransition = saleGenerator.saveEntityTransition;

const saleTransferHydraClient = new HydraClient(`/${CLIENT_TOKEN}/sales`);
export const postSaleTransfer = (...args) => dispatch => {
  const sendRequest = saleTransferHydraClient.saveEntityTransfer(...args);

  return sendRequest;
};

// articles
const articleGenerator = generator.with(`/${CLIENT_TOKEN}/articles`, schemas.article);
export const fetchArticleList = articleGenerator.fetchEntityList;
export const saveArticle = articleGenerator.saveEntity;
export const deleteArticle = articleGenerator.deleteEntity;

// articleBehaviors
const articleBehaviorsGenerator = generator.with(`/${CLIENT_TOKEN}/article_behaviors`, schemas.articleBehaviors);
export const saveArticleBehavior = articleBehaviorsGenerator.saveEntity;
export const fetchArticleBehaviorsList = articleBehaviorsGenerator.fetchEntityList;



// WEBPACK FOOTER //
// ./src/shadow-client/endpoints/saleApi/index.js